import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Typography, Divider, TextField, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Snackbar, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { deleteProductAssetLinkAPI } from './DesignMgmtAPI';
import { deleteProductassetObj, setProductassetList, setProductSelectImageModal, updateProductObj } from 'store/slice/PharmaSlice';
import { setImageType } from 'store/slice/ImageGallerySlice';
import { getProductassetInfoByProductidandtypeAPI } from '../../../productasset/ProductassetAPI';
import SelectImageActionModal from '../selectImage/SelectImageActionModal';
import ImageIcon from '@mui/icons-material/Image';
import { deleteAPI } from '../../../productasset/ProductassetAPI';
import Alert from '@mui/material/Alert';
import { setSelectedAssetIdList } from 'store/slice/ImageGallerySlice';
import { submitDesignQaApprovalAPI } from 'api/OmsOrdermgmtWebServices';
import { approveProductDesignAPI, revokeCustomerApprovalAPI } from 'api/OmsOrdermgmtWebServices';
import {setSnackbarMessage, setSnackbarOpen} from 'store/slice/AppSlice';

export default function DesignerUploadDesign() {
    const dispatch = useDispatch();
    const { selectedImagePath, selectedImage, imageType } = useSelector((state) => state.imagegalleryslice);
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const { productassetList } = useSelector((state) => state.pharmaslice);
    const {snackbarMessage, snackbarOpen}= useSelector((state) => state.appslice);
    const [approvalDate, setApprovalDate] = useState('');
    const [customerApproved, setCustomerApproved] = useState(false); // <-- default is false (not selected)
    const [viewImage, setViewImage] = useState(null); // {src, name}
    const [deleteDialog, setDeleteDialog] = useState({ open: false, assetObj: null });
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [radioDateError, setRadioDateError] = useState(false);
    const isQaApproved = productObj.designstatusqa === "QA APPROVED";
   
    useEffect(() => {
        dispatch(setImageType("CUSTOMER"));
    },[]);
    useEffect(() => {
        if (imageType === "CUSTOMER") {
            setCustomerApproved(false); // Always start unselected
        } else if (imageType === "QA") {
            setCustomerApproved(false); // Always start unselected
        }
    }, [imageType, productObj.designstatus, productObj.designstatusqa]);

    useEffect(() => {
        if (productObj.designstatus === "CUSTOMER APPROVED") {
            setCustomerApproved(true);
        } else if (imageType === "CUSTOMER" || imageType === "QA") {
            setCustomerApproved(false);
        }
    }, [imageType, productObj.designstatus, productObj.designstatusqa]);

    useEffect(() => {
        if (productassetList && productassetList.length > 0) {
            dispatch(setSelectedAssetIdList(productassetList.map(obj => obj.assetid).join(',')));
        }
    },[productassetList]);
    const fetchLinkedAssetSuccessCallBack = (responseObj) => {
        //dispatch(setSelectedAssetObjList(responseObj));
        dispatch(setProductassetList(responseObj));
        dispatch(setSelectedAssetIdList(responseObj.map(obj => obj.assetid).join(',')));
        
    };
    function getCommaSeparatedAssetIds(list) {
        if (!Array.isArray(list) || list.length === 0) return '';
        return list.map(item => item.assitId).join(',');
    }
    const fetchLinkedAssetFailureCallBack = (message) => {
        alert(message)
    };
    useEffect(() => {
        getProductassetInfoByProductidandtypeAPI( "CUSTOMER",productObj.id, () => { }, fetchLinkedAssetSuccessCallBack)
    }, [])

    const deleteProductAssetLinkSuccessCallBack = (responseObj) => {
        dispatch(deleteProductassetObj(responseObj.id));
    };
    const deleteProductAssetLink = (linkId) => {
        deleteProductAssetLinkAPI(linkId, deleteProductAssetLinkSuccessCallBack)
    };
    const copyLink = (assetpath) => {
        navigator.clipboard.writeText(assetpath)
            .then(() => {
                alert('Link copied to clipboard!');
            })
            .catch(err => {
                console.error('Failed to copy the link: ', err);
            });
    };
    const getListHeight = () => {
        if (productObj.statusname === 'DESIGN APPROVAL' || productObj.statusname === 'PLANNING') return '45vh';
        else return '50vh'
    };
    const handleTabClick = (clickedTab) => {
        // setSelectedTab(clickedTab);
        dispatch(setImageType(clickedTab));
        getProductassetInfoByProductidandtypeAPI(clickedTab, productObj.id, () => { }, fetchLinkedAssetSuccessCallBack)
    };

    // Handler for approval/revoke button
    const handleApprovalToggle = () => {
        //setCustomerApproved(!customerApproved);
        // Add API logic here if needed
    };
    const submitForQAApproval = () => {
        submitDesignQaApprovalAPI(
            {
                "productId": productObj.id,
                "designApprovalDate": approvalDate
            },
            () => {
                dispatch(setSnackbarMessage("Submitted for QA approval successfully."));
                dispatch(setSnackbarOpen(true));
                dispatch(setProductSelectImageModal(false));
            },
            (error) => {
                console.error("Error submitting for QA approval:", error);
                dispatch(setSnackbarMessage("Error submitting for QA approval."));
                dispatch(setSnackbarOpen(true));
            }
        );
        // You can also dispatch any other actions if needed
    }
    // Filter customer linked images
    const customerLinkedImage = productassetList
        ? productassetList.filter(obj => obj.imagetype === 'CUSTOMER')
        : [];

    // Delete logic
    const handleDelete = (assetObj) => {
        setDeleteDialog({ open: true, assetObj });
    };

    const confirmDelete = () => {
        if (deleteDialog.assetObj) {
            deleteAPI(deleteDialog.assetObj.id, () => {
                dispatch(deleteProductassetObj(deleteDialog.assetObj.id));
                setDeleteDialog({ open: false, assetObj: null });
                setViewImage(null);
                dispatch(setSnackbarMessage("Asset delinked successfully."));
                dispatch(setSnackbarOpen(true));
            });
        }
    };

    const cancelDelete = () => {
        setDeleteDialog({ open: false, assetObj: null });
    };

    const isFutureDate = (dateStr) => {
        if (!dateStr) return false;
        const today = new Date();
        today.setHours(0,0,0,0);
        const inputDate = new Date(dateStr);
        inputDate.setHours(0,0,0,0);
        return inputDate > today;
    };
    const markAsCustomerApproved = () => {
        if (isFutureDate(approvalDate)) {
            setRadioDateError(true);
            return;
        }
        setRadioDateError(false);
        approveProductDesignAPI(
            { "productId": productObj.id, "designApprovalDate": approvalDate },
            (responseObj) => {
                //dispatch(setProductSelectImageModal(false));
                dispatch(setSnackbarMessage("Design marked as Customer Approved successfully. Now, link designs and submit them for QA Approval."));
                dispatch(setSnackbarOpen(true));
                dispatch(updateProductObj(responseObj.productInfo));
            },
            (error) => {
                console.error("Error marking as customer approved:", error);
                dispatch(setSnackbarMessage(error));
                dispatch(setSnackbarOpen(true));
            }
        );
    }

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    height: { lg: '80vh', md: '80vh', sm:'80vh', xs: '80vh' },
                    overflow: 'hidden',
                    backgroundColor: 'secondary.100',
                }}
            >
                <Grid
                    container
                    justifyContent="center"
                    sx={{
                        height: '100%',
                        width: '100%',
                        margin: 0,
                        flexWrap: { xs: 'wrap', md: 'nowrap' },
                        overflow: 'hidden',
                        // Add gap between columns
                        columnGap: { xs: 0, md: 2, lg: 3 }, // Adjust as needed for spacing
                    }}
                >
                    {/* Section 1: Customer Approved Images */}
                    {/* <Grid
                        item
                        lg={9}
                        md={9}
                        sm={9}
                        xs={12}
                        
                        sx={{

                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: 'white',
                                borderRadius: 2,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                border: '1px solid #e0e0e0',
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    m: 2,
                                    backgroundColor: 'primary.lighter',
                                    p:1
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 'bold',
                                        px: 2,
                                        py: 1,
                                        borderRadius: 1,
                                        display: 'inline-block'
                                    }}
                                >
                                    Customer Images
                                </Typography>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<ImageIcon />}
                                    onClick={() => {
                                        dispatch(setProductSelectImageModal(true));
                                        dispatch(setImageType("CUSTOMER"));
                                    }}
                                    disabled={isQaApproved} // <-- disable if QA APPROVED
                                >
                                    Asset Library
                                </Button>
                            </Box>
                            <Divider sx={{}} />
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    borderRadius: 2,
                                    overflowY: 'auto',
                                    backgroundColor: 'white',
                                    height: '100%',
                                    maxHeight: { xs: '35vh', md: '55vh', lg: '60vh' }, // Add a maxHeight for scrolling
                                }}
                            >
                                <Grid container sx={{ width: '100%' }} justifyContent="space-between" alignItems="center">
                                    {customerLinkedImage.length > 0 ? customerLinkedImage.map(productAssetObj => (
                                        <Grid item key={productAssetObj.id} xs={12} sm={4} md={3} lg={4} sx={{ p: 1 }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    p: 1,
                                                    borderRadius: 2,
                                                    transition: 'box-shadow 0.2s, background 0.2s, border 0.2s',
                                                    backgroundColor: 'secondary.100',
                                                    border: selectedImageId === productAssetObj.id ? '2px solid #333' : '2px solid transparent',
                                                    boxShadow: selectedImageId === productAssetObj.id ? 3 : 0,
                                                    '&:hover': {
                                                        backgroundColor: 'primary.lighter',
                                                    },
                                                    cursor: 'pointer',
                                                    position: 'relative'
                                                }}
                                                onClick={() => setViewImage({ src: productAssetObj.assetpath, name: productAssetObj.name, id: productAssetObj.id })}
                                                onMouseEnter={() => setSelectedImageId(productAssetObj.id)}
                                                onMouseLeave={() => setSelectedImageId(null)}
                                            >
                                                <img
                                                    src={productAssetObj.assetpath}
                                                    style={{
                                                        width: '200px',
                                                        height: '200px',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer'
                                                    }}
                                                    alt={productAssetObj.name}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    noWrap
                                                    title={productAssetObj.name}
                                                    sx={{
                                                        maxWidth: '200px',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        display: 'block',
                                                        mt: 1,
                                                        color: '#1976d2',
                                                        textAlign: 'center',
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {productAssetObj.name}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    )) : (
                                        <Grid item xs={12} sx={{padding:5, minHeight:'200px', justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                                            <Typography variant="h5" color="text.secondary" sx={{borderRadius:5, padding:10, backgroundColor:'secondary.100',}}>
                                                
                                                Click on 'Asset Library' Button to Upload / Select Assets.
                                            </Typography>
                                            
                                        </Grid>
                                    )}
                                </Grid>
                            </Box>
                            
                        </Box>
                    </Grid> */}
                    {/* Section 2: Designer Approval Actions */}
                    <Grid
                        item
                        lg={6}
                        md={3}
                        sm={3}
                        xs={12}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0,
                            mt: { xs: 0, md: 0 }, // <-- Add this line for top margin on mobile
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: 'white',
                                borderRadius: 2,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                border: '1px solid #e0e0e0',
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    mt: 2,
                                    mx: 2,
                                    fontWeight: 'bold',
                                    backgroundColor: 'primary.lighter',
                                    px: 2,
                                    py: 1,
                                    borderRadius: 1,
                                    display: 'inline-block'
                                }}
                            >
                                Approval Confirmation
                            </Typography>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    borderRadius: 2,
                                    p: 1,
                                    overflowY: 'auto',
                                    backgroundColor: 'white',
                                    height: '100%',
                                    
                                }}
                            >
                                
                                <Grid container alignItems="center">
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Approval Date"
                                            type="date"
                                            value={approvalDate}
                                            onChange={e => {
                                                const val = e.target.value;
                                                // Only allow today or before
                                                const today = new Date();
                                                today.setHours(0,0,0,0);
                                                const inputDate = new Date(val);
                                                inputDate.setHours(0,0,0,0);
                                                if (!val || inputDate <= today) {
                                                    setApprovalDate(val);
                                                    setRadioDateError(false); // Clear error when date is set
                                                }
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            disabled={productObj.designstatus === 'CUSTOMER APPROVED'}
                                            inputProps={{
                                                max: new Date().toISOString().split('T')[0]
                                            }}
                                            error={radioDateError}
                                            helperText={
                                                radioDateError
                                                    ? "Please select a date before selecting customer approval"
                                                    : ""
                                            }
                                            sx={{
                                                ...(productObj.designstatus === 'CUSTOMER APPROVED' && {
                                                    backgroundColor: '#f5f5f5',
                                                    color: 'text.disabled',
                                                    '& .MuiInputBase-input.Mui-disabled': {
                                                        WebkitTextFillColor: '#9e9e9e',
                                                    },
                                                })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sx={{mt: 2}}>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                row
                                                value={customerApproved ? "approved" : ""}
                                                onChange={e => {
                                                    if (!approvalDate) {
                                                        setRadioDateError(true);
                                                    } else if (customerApproved) {
                                                        setCustomerApproved(false); // Deselect if already selected
                                                    } else {
                                                        setCustomerApproved(true);
                                                    }
                                                }}
                                                name="customerApprovedRadio"
                                            >
                                                <FormControlLabel
                                                    value="approved"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            checked={customerApproved}
                                                            onClick={() => {
                                                                if (!approvalDate) {
                                                                    setRadioDateError(true);
                                                                } else if (customerApproved) {
                                                                    setCustomerApproved(false); // Deselect on click if already selected
                                                                } else {
                                                                    setCustomerApproved(true);
                                                                }
                                                            }}
                                                            disabled={!approvalDate || productObj.designstatus === 'CUSTOMER APPROVED'}
                                                            sx={{
                                                                ...(productObj.designstatus === 'CUSTOMER APPROVED' && {
                                                                    color: '#bdbdbd !important',
                                                                })
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                ...(productObj.designstatus === 'CUSTOMER APPROVED' && {
                                                                    color: '#bdbdbd',
                                                                })
                                                            }}
                                                        >
                                                            I confirm that Customer has approved attached Assets on above mentioned date
                                                        </Typography>
                                                    }
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider sx={{ mt: 3, mb: 2 }} />
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {productObj.designstatus === 'CUSTOMER APPROVED' ? (
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={() => {
                                                        revokeCustomerApprovalAPI(
                                                            { productid: productObj.id },
                                                            (responseObj) => {
                                                                dispatch(setSnackbarMessage("Customer approval revoked."));
                                                                dispatch(setSnackbarOpen(true));
                                                                dispatch(updateProductObj(responseObj.productInfo));
                                                            },
                                                            (error) => {
                                                                dispatch(setSnackbarMessage("Error revoking customer approval."));
                                                                dispatch(setSnackbarOpen(true));
                                                            }
                                                        );
                                                    }}
                                                    disabled={isQaApproved} // <-- disable if QA APPROVED
                                                >
                                                    Revoke Customer Approval
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="contained"
                                                    onClick={markAsCustomerApproved}
                                                    disabled={!customerApproved}
                                                >
                                                    Save
                                                </Button>
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Image View Dialog */}
                    <Dialog
                        open={!!viewImage}
                        onClose={() => setViewImage(null)}
                        maxWidth={true}
                        PaperProps={{
                            sx: {
                                width: 'auto',
                                maxWidth: '90vw',
                                minWidth: '320px',
                                p: 0,
                                borderRadius: 2,
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, pb: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                {viewImage?.name || "Image"}
                            </Typography>
                            <IconButton onClick={() => setViewImage(null)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Divider />
                        <DialogContent
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                p: 3,
                                minWidth: '320px',
                                minHeight: '200px',
                                maxWidth: '80vw',
                                maxHeight: '70vh',
                            }}
                        >
                            <img
                                src={viewImage?.src}
                                alt={viewImage?.name}
                                style={{
                                    maxWidth: '70vw',
                                    maxHeight: '60vh',
                                    display: 'block',
                                    margin: '0 auto'
                                }}
                            />
                        </DialogContent>
                        <Divider />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: 2, pt: 1 }}>
                            <Button
                                onClick={() => setDeleteDialog({ open: true, assetObj: { id: viewImage?.id, assetpath: viewImage?.src, assetname: viewImage?.name } })}
                                color="error"
                                variant="contained"
                                startIcon={<DeleteIcon />}
                                disabled={isQaApproved} // <-- disable if QA APPROVED
                            >
                                De-link from Product
                            </Button>
                        </Box>
                        {/* Delete Confirmation Dialog as modal over image dialog */}
                        <Dialog
                            open={deleteDialog.open}
                            onClose={cancelDelete}
                            maxWidth="xs"
                            PaperProps={{
                                sx: {
                                    zIndex: 1601, // higher than the image dialog
                                }
                            }}
                        >
                            <DialogTitle>Confirm Delink</DialogTitle>
                            <DialogContent>
                                <Typography>Are you sure you want to delink '{viewImage?.name || "Asset"}' from the Product?</Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={cancelDelete} color="primary">Cancel</Button>
                                <Button onClick={confirmDelete} color="error" variant="contained">De-link from Product</Button>
                            </DialogActions>
                        </Dialog>
                    </Dialog>



                    {/* Existing modal and other logic */}
                    <SelectImageActionModal />
                </Grid>
            </Box>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={10000}
                onClose={() => dispatch(setSnackbarOpen(false))}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => dispatch(setSnackbarOpen(false))}
                    severity="success"
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Snackbar
                open={radioDateError}
                autoHideDuration={10000}
                onClose={() => setRadioDateError(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setRadioDateError(false)}
                    severity="error"
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    Please select a date before selecting customer approval
                </Alert>
            </Snackbar>
        </>
    );
}